define 'controller/ColorTileController', ['jquery'], ($) ->
  class ColorTileController

    constructor: (@$el) ->
      @_toggleBackview()
      @_colorTiles()
      @_colorTilesSimilarArticles()
      @_colorTilesGeneralSlider()
      @_hideBrokenColorImages()
      @_showColorCount()

    _toggleBackview: ->
      $('.toggle-backview').mouseover ->
        backview = this.getAttribute('data-backview')
        if backview
          $(this).attr('src', backview)
      $('.toggle-backview').mouseout ->
        $(this).attr('src', this.getAttribute('data-frontview'))

    _colorTiles: ->
      @$el.find('.js_colorpatch').mouseover ->
        $this = $(this)
        image = $this.closest('.article').find('.article__picture > img')
        image.attr('src', $this.data('frontview'))
        image.attr('data-frontview', $this.data('frontview'))
        image.attr('data-backview', $this.data('backview'))
        articlenumber = $this.data('articlenumber')
        detailsUrl = $this.data('href')
        $this.closest('.article').data('articlenumber', articlenumber)
        $this.closest('.article').find('.article__name > a').attr('href', detailsUrl)

      @$el.find('.js_colorpatch_slider').on 'mouseover', ->
        $this = $(this)
        $article =  $this.closest('.article')
        slider = $article.find('.js-picture-slider')
        sliderPicturesNew = $this.data('pictures')
        slider.data 'pictures', sliderPicturesNew
        slider.data 'position', 0
        slider.attr 'src', sliderPicturesNew[0]
        articlenumber = $this.data('articlenumber')
        detailsUrl = $this.data('href')
        $article.data('articlenumber', articlenumber)
        $article.find('.article__name > a').attr('href', detailsUrl)

        $article.find('.article__color.active').removeClass('active')
        $this.closest('.article__color').addClass('active')

        return

    _colorTilesSimilarArticles: ->
      $('.js_colorpatch_sa').mouseover ->
        image = $(this).closest('.product__similar-items__item').find('.product__similar-items__picture a img')
        image.attr('src', $(this).data('picture'))
        detailsUrl = $(this).data('detailsUrl')
        $(this).closest('.product__similar-items__item').find('.product__similar-items__name > a').attr('href', detailsUrl)
        $(this).closest('.product__similar-items__item').find('.product__similar-items__picture > a').attr('href', detailsUrl)

    _colorTilesGeneralSlider: ->
      $('.js_colorpatch_gs').mouseover ->
        image = $(this).closest('.general-slider__product').find('.general-slider__product__picture a img')
        image.attr('src', $(this).data('picture'))
        detailsUrl = $(this).data('detailsUrl')
        $(this).closest('.general-slider__product').find('.general-slider__product__name > a').attr('href', detailsUrl)
        $(this).closest('.general-slider__product').find('.general-slider__product__picture > a').attr('href', detailsUrl)

    _hideBrokenColorImages: ->
      $('.category .article__color img').on 'error', (e) ->
        $(@).hide()
        return

    _showColorCount: ->
      $('.article__colors').each (index) ->
        count = $(this).data('color-count')
        displayColorCountDisplaySmall = count - 3
        displayColorCountDisplayLarge = count - 6
        if displayColorCountDisplaySmall >= 1
          $(this).find('.article__colors__count .three-color-display').html('+' + displayColorCountDisplaySmall)
        if displayColorCountDisplayLarge >= 1
          $(this).find('.article__colors__count .six-color-display').html('+' + displayColorCountDisplayLarge)
        
      return      

    destroy: ->
      @$el.off()